import { createContext, useContext } from 'react'

export const UserContext = createContext<Maybe<GetCurrentUserQuery['currentUser']>>(null)

export const UserProvider = UserContext.Provider

export const useUserContext = () => useContext(UserContext)
